export const APPLICATION_ROUTES = {
	HOME: "/",
	STUDY: "/study",
	STUDY_GROUPS: "/study/groups",
	STUDY_COURSES: "/study/courses",
	// The Bible workspace (on-bible-kb 50-architecture/web/bible-reader-workspace.md) — promoted here 28.08.2026.
	// BIBLE_NEXT ("/new-bible") stays mounted on the same component for anyone
	// with an old link; every navigation from within the reader now targets BIBLE.
	BIBLE: "/bible",
	BIBLE_NEXT: "/new-bible",
	// The old query-param reader, kept reachable while the new one settles.
	OLD_BIBLE: "/old-bible",
	CHATS: "/chats",
	DONATE: "/donate",
	ABOUT: "/about",
	// Guest landing preview — local and staging only until it replaces "/" together with the dashboard.
	WELCOME: "/welcome",
	// Signed-in dashboard preview — local and staging only, ships to "/" together with the landing.
	DASHBOARD: "/dashboard",
	PROFILE: "/profile",
	PROFILE_QUESTIONS: "/profile/questions",
	PROFILE_NOTES: "/profile/notes",
	PROFILE_NOTE_NEW: "/profile/notes/new",
	PROFILE_NOTE_DETAIL: "/profile/notes/:noteId",
	PROFILE_NOTES_FOLDER: "/profile/notes/folders",
	PROFILE_ACTIVITY: "/profile/activity",
	PROFILE_MENTORSHIP: "/profile/mentorship",
	AUTH: "/auth",
	LOGIN: "/auth/login",
	REGISTRATION: "/auth/registration",
	OAUTH_GMAIL: "/oauth/gmail",
	ADMIN: "/admin",
	ADMIN_HOME: "/admin/home_page",
	ADMIN_GROUPS: "/admin/groups",
	ADMIN_QUESTIONS: "/admin/questions",
	ADMIN_COURSES: "/admin/courses",
	ADMIN_CREATE_LESSON: "/admin/create_lesson",
	ADMIN_CREATE_NOTEBOOK: "/admin/create_notebook",
	ADMIN_NOTEBOOK_PREVIEW: "/admin/notebook_preview",
	ADMIN_LESSON_PREVIEW: "/admin/lesson_preview",
	ADMIN_COURSE_PREVIEW: "/admin/course_preview",
	ADMIN_GROUP_PREVIEW: "/admin/group_preview",
	ADMIN_USERS: "/admin/users",
	ADMIN_ANALYTICS: "/admin/analytics",
	ADMIN_FEEDBACKS: "/admin/feedbacks",
	USER_LESSON: "/lesson",
	USER_SHARED_LESSON: "/shared_lesson",
	SHARED_NOTE: "/shared-notes",
	PRIVACY_POLICY: "/privacy",
	TERMS_OF_SERVICE: "/terms",
};

// `?reason=` on the auth routes: says why a guest was sent there, so the title can say it too.
export const AUTH_REASONS = {
	COPY_NOTE: "copy-note",
};
